import { FC } from 'react';
import { cn } from 'components/utils';

const SkeletonField: FC<{ titleWidth?: string; inputHeight?: string }> = ({
  titleWidth = 'w-1/4',
  inputHeight = 'h-20',
}) => (
  <div className="flex gap-2 mb-4 flex-col">
    <div
      className={cn(
        'bg-gray-light animate-pulse rounded-md',
        titleWidth,
        'h-4'
      )}
    />
    <div
      className={cn(
        'bg-gray-light animate-pulse rounded-md',
        inputHeight,
        'w-full'
      )}
    />
  </div>
);

const MedicalReportCallSkeleton: FC = () => {
  return (
    <div className="flex-1 flex flex-col justify-between h-[calc(100%_-_60px)]">
      <div className="flex-grow pt-4 px-4 overflow-auto">
        <SkeletonField />
        <SkeletonField />
        <SkeletonField inputHeight="h-12" />
        <SkeletonField />
      </div>
      <div className="pb-4 px-4 flex gap-2 pt-6 border-t border-gray-200">
        {/* Skeleton for Delete Button (optional) */}
        <div className="bg-gray-light animate-pulse rounded h-10 w-10"></div>
        {/* Skeleton for Submit Button */}
        <div className="bg-gray-light animate-pulse rounded h-10 w-24 ml-auto"></div>
      </div>
    </div>
  );
};

export default MedicalReportCallSkeleton;
